<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/cabeceras/vinos.jpg'); filter: blur(1px); -webkit-filter: blur(1px);"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">Carta de vinos</h1>
          <div class="text-center">
            <!-- <h4>gsdgsdg</h4> -->
          </div>
        </div>
      </div>
    </div>
    <div class="section mb-1">
      <div class="container" style="margin-top: -50px !important;">

        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h3 class="title mb-4">D.O. Rioja</h3>
            <div v-for="rioja in riojas" :key="rioja.id">
              <h5 class="">{{ rioja.title }}</h5>
              <h5 class="mb-4" style="margin-top: -10px !important;"><b>{{ rioja.price }}</b></h5>
            </div>
          </div>
        </div>
        <hr style="width: 50%;">
        <div class="row" style="margin-top: -25px !important;">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="title mb-4">Otras Denominaciones de Origen</h4>
            <div v-for="otras_do in otras_dos" :key="otras_do.id">
              <h5 class="">{{ otras_do.title }}</h5>
              <h5 class="mb-4" style="margin-top: -10px !important;"><b>{{ otras_do.price }}</b></h5>
            </div>
          </div>
        </div>
        <hr style="width: 50%;">
        <div class="row" style="margin-top: -25px !important;">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="title mb-4">Blancos / Txakolis</h4>
            <div v-for="blanco in blancos" :key="blanco.id">
              <h5 class="">{{ blanco.title }}</h5>
              <h5 class="mb-4" style="margin-top: -10px !important;"><b>{{ blanco.price }}</b></h5>
            </div>
          </div>
        </div>
        <hr style="width: 50%;">
        <div class="row" style="margin-top: -25px !important;">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="title mb-4">Espumosos</h4>
            <div v-for="espumoso in espumosos" :key="espumoso.id">
              <h5 class="">{{ espumoso.title }}</h5>
              <h5 class="mb-4" style="margin-top: -10px !important;"><b>{{ espumoso.price }}</b></h5>
            </div>
          </div>
        </div>
        <hr style="width: 50%;">
        <div class="row" style="margin-top: -25px !important;">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h4 class="title mb-1">Eladio Piñeiro rural wines</h4>
            <img src="img/vinos/eladio.png" alt="Eladio Piñeiro" style="max-width: 70px; margin-bottom: 20px;" />
            <div v-for="eladio in eladios" :key="eladio.id">
              <h5 class="">{{ eladio.title }}</h5>
              <h5 class="text-secondary" style="margin-top: -10px !important; font-size: medium;">{{ eladio.subtitle }}</h5>
              <h5 class="mb-4" style="margin-top: -10px !important;"><b>{{ eladio.price }}</b></h5>
            </div>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>
<script>
export default {
  name: 'vinos',
  bodyClass: 'landing-page',
  metaInfo: {
    title: 'Restaurante Torreondo',
    titleTemplate: '%s | Carta de vinos',
    meta: [
      { name: 'description', content: 'Siempre con una selecta y exclusiva selección de vinos' },
      { property: 'og:title', content: 'Restaurante Torreondo'},
      { property: 'og:site_name', content: 'Siempre con una selecta y exclusiva selección de vinos'},
      { property: 'og:description', content: 'Siempre con una selecta y exclusiva selección de vinos' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://www.restaurantetorreondo.com' },
      { property: 'og:image', content: 'https://www.restaurantetorreondo.com/img/favicon.ico' }
    ]
  },
  mounted() {
    this.$gtag.pageview(this.$route);
  },
  data() {
    return {
      riojas: [
        {
          title: 'Campillo (Crianza)',
          price: '19,50€'
        },
        {
          title: 'Sierra Cantabria (Crianza)',
          price: '19,50€'
        },
        {
          title: 'Ramón Bilbao (Edición limitada)',
          price: '22,50€'
        },
        {
          title: 'Viña Alberdi',
          price: '22€'
        },
        {
          title: 'Viña Alberdi magnum',
          price: '38,50€'
        }
      ],
      otras_dos: [
        {
          title: 'Portia (D.O. Ribera de Duero)',
          price: '16,50€'
        },
        {
          title: 'Bardos (D.O. Ribera de Duero)',
          price: '21,50€'
        },
        {
          title: 'Habla del Silencio (D.O. Extremadura)',
          price: '21,50€'
        },
        {
          title: 'Matsu Recio (D.O. Toro)',
          price: '24,50€'
        },
      ],
      blancos: [
        {
          title: 'Galanta (D.O. Bizkaia)',
          price: '22€'
        },
        {
          title: 'Terra do Lobo (D.O. Monterrei)',
          price: '17€'
        },
      ],
      espumosos: [
        {
          title: 'Recadero (Corpinnat)',
          price: '35€'
        },
        {
          title: 'Aire de Protos Rosé (D.O. Ribera de Duero)',
          price: '15€'
        },
        {
          title: 'Sierra Cantabria Rosé (D.O. Rioja)',
          price: '18€'
        },
        {
          title: 'Cavas',
          price: 'Consultar'
        },
        {
          title: 'Champagne',
          price: 'Consultar'
        },
      ],
      eladios: [
        {
          title: 'Flor de Carme (100% Albariño)',
          subtitle: '15 meses de doble lías. Albariño ancestral y en perfecta amornia de frescura, elegancia y amplitud.',
          price: '49€'
        },
        {
          title: 'Amodiño (100% Albariño)',
          subtitle: '5 meses en lías de tres añadas. Como su nombre indica "Amodiño" (despacito), para hacer las grandes cosas hay que hacerlas despacito. Un Albariño que destaca por su complejidad.',
          price: '41€'
        },
        {
          title: 'Flor de Carme Millesime (90% Albariño, 10% Espadeiro)',
          subtitle: 'Espumoso ancestral Brut Nature, es un Albariño excepciona, elaborado con técnicas acenstrales en los terruños del Valle de Salnes.',
          price: '45€'
        },
        {
          title: 'Envidia Cochina (100% Albariño)',
          subtitle: 'Tete de Cuvee 6 meses de lías, el coupage incluye un 20% de lías de la añada anterior añadiendo complejidad y profundidad. Su etiqueta inspirada en la expresión “Envidia Cochina” presentando una viñeta única cada año, añadiendo un toque de historia',
          price: '35€'
        },
        {
          title: 'La Ola (100% Albariño)',
          subtitle: 'Cultivado en los terruños más exclusivos del Valle de Salnes. 6 meses de crianza sobre lías finas y 2 años de crianza en botella',
          price: '27€'
        },
        {
          title: 'Novoa (100% Caiño)',
          subtitle: 'Cultivado en los terruños más exclusivos del Valle de Salnes. 6 meses de crianza sobre lías finas y 2 años de crianza en botella',
          price: '35€'
        },
      ],
    };
  }
};
</script>
<style></style>
